"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Container = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _text = _interopRequireDefault(require("@ux/text"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _density = require("@site/pattern-library-utils/density");
var _attachment = _interopRequireDefault(require("../../../attachment"));
var _configContext = require("../../../context/config-context");
var _bundleContext = require("../../../context/bundle-context");
var _functions = require("../../../utils/functions");
var _domainUtils = require("../../../utils/domain-utils");
const Container = exports.Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pc-cbxwghi"
});
const GridContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "GridContainer",
  class: "pc-g15rg3l4"
});

/**
 * AttachmentRow Component.
 *
 * @param {Object} props React props
 * @param {String} props.rowTitle Title for each row item
 * @param {Array} props.items Array of attachment item
 * @param {Function} props.handleChange Function to handle change event
 * @returns {React.ReactElement} AttachmentRow Component
 * @public
 */

function AttachmentRow({
  rowTitle,
  items,
  handleChange
}) {
  const {
    configData
  } = (0, _configContext.useConfig)();
  const {
    isComponentIncluded
  } = (0, _bundleContext.useBundleContext)();
  const instance = configData?.instance;
  if (!items) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(Container, {
    "data-cy": "attachment-row-item",
    className: rowTitle ? 'hasBorder' : ''
  }, rowTitle && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    text: rowTitle,
    size: 5,
    "data-cy": "row-title"
  }), /*#__PURE__*/_react.default.createElement(GridContainer, null, items?.map((item, index) => {
    const {
      id,
      instancePath,
      displayDisable,
      attachmentImage,
      attachmentSubtitle,
      options,
      selection
    } = item;
    const isPillToggle = options && options.length > 1;
    let inputValue = id;
    let selectedOptionIndex = 0;
    const isIncludedInBundle = isComponentIncluded(instancePath);
    if (isPillToggle && options && options.length > 0) {
      const optionData = options.find(option => option.id === selection);
      inputValue = optionData?.value || optionData?._name || id;
      selectedOptionIndex = isIncludedInBundle ? 0 : options.findIndex(option => option.id === selection);
    }
    const isChecked = isIncludedInBundle || inputValue === selection;

    // Custom onChange handler for multi-domain scenario
    const handleAttachmentChange = (checked, inputName, value) => {
      const [, displayArea, itemName] = (0, _functions.parseInstancePath)(instancePath);

      // If this is multi-domain scenario, apply change to all products with same itemName
      if ((0, _domainUtils.isMultiDomain)(configData?.environment)) {
        const productsWithSameItemName = (0, _functions.getAllProductsWithSameItem)(instance, itemName, displayArea);

        // Create array of productInstancePaths and pass to handleChange
        const productInstancePaths = productsWithSameItemName.map(product => `${product}/${displayArea}/${itemName}`);
        handleChange(checked, productInstancePaths, value, isPillToggle);
      } else {
        // Handle single path (original behavior)
        handleChange(checked, inputName, value, isPillToggle);
      }
    };
    return /*#__PURE__*/_react.default.createElement(_attachment.default, (0, _extends2.default)({
      key: index
    }, item, {
      onChange: handleAttachmentChange,
      inputName: instancePath,
      inputValue: inputValue,
      displayDisable: displayDisable,
      checked: isChecked,
      image: attachmentImage,
      secondaryTitle: attachmentSubtitle,
      options: isPillToggle ? options : [],
      selectedOption: selectedOptionIndex
    }));
  })));
}
var _default = exports.default = AttachmentRow;
AttachmentRow.propTypes = {
  rowTitle: _propTypes.default.string,
  items: _propTypes.default.array,
  handleChange: _propTypes.default.func
};